// src/components/Header.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MobileMenu from './MobileMenu';
import { getToken, isTokenValid, removeToken } from '../utils/jwtUtils';

function Header() {
  const [coursesMenuAnchor, setCoursesMenuAnchor] = useState(null);
  const [userMenuAnchor, setUserMenuAnchor] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();

  // Check if user is logged in
  useEffect(() => {
    const token = getToken();
    if (token && isTokenValid(token)) {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
    }
  }, []);

  const handleOpenMenu = (setAnchor) => (event) => {
    setAnchor(event.currentTarget);
  };

  const handleCloseMenu = (setAnchor) => () => {
    setAnchor(null);
  };

  const handleLogout = () => {
    removeToken();
    setIsAuthenticated(false);
    navigate('/');
  };

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        bgcolor: '#edf1fa',
        color: '#333',
        borderBottom: '1px solid #e0e0e0',
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters>
          {/* Logo */}
          <Box
            component="a"
            href="/"
            sx={{
              flexGrow: 1,
              textDecoration: 'none',
              color: '#667',
              fontSize: '1.3rem',
              fontWeight: '600',
            }}
          >
            CloudSec Network
          </Box>

          {/* Desktop Navigation */}
          <Box
            sx={{
              display: { xs: 'none', md: 'flex' },
              ml: 'auto',
              alignItems: 'center',
            }}
          >
            <Button href="/certificate/verify" sx={{ mx: 1, color: '#333', textTransform: 'none', fontSize: '0.95rem' }}>
              Verify Cert
            </Button>
            <Button href="https://cloudsecnetwork.com/community"
              sx={{ mx: 1, color: '#333', textTransform: 'none', fontSize: '0.95rem' }}>
              Community
            </Button>
            <Button href="https://blog.cloudsecnetwork.com/"
              sx={{ mx: 1, color: '#333', textTransform: 'none', fontSize: '0.95rem' }}>
              Blog
            </Button>

            {/* Conditional Sign In / User Icon */}
            {isAuthenticated ? (
              <>
                <IconButton
                  onClick={handleOpenMenu(setUserMenuAnchor)}
                  sx={{ ml: 2, color: '#333' }}
                >
                  <AccountCircleIcon fontSize="large" />
                </IconButton>
                <Menu
                  anchorEl={userMenuAnchor}
                  open={Boolean(userMenuAnchor)}
                  onClose={handleCloseMenu(setUserMenuAnchor)}
                  PaperProps={{ sx: { bgcolor: '#fff', color: '#333' } }}
                >
                  <MenuItem onClick={() => navigate('/profile')}>
                    Edit Profile
                  </MenuItem>
                  <MenuItem onClick={() => navigate('/my-learning')}>
                    My Learning
                  </MenuItem>
                  <MenuItem onClick={() => navigate('/my-learning/certificates')}>
                    Certificates
                  </MenuItem>
                  <MenuItem onClick={handleLogout}>Log Out</MenuItem>
                </Menu>
              </>
            ) : (
              <Button
                href="/signin"
                variant="outlined"
                sx={{
                  ml: 2,
                  color: '#333',
                  fontSize: '0.9rem',
                  px: '1.5rem',
                  borderColor: '#333',
                  textTransform: 'none',
                  '&:hover': {
                    bgcolor: '#f5f5f5',
                    borderColor: '#333',
                  },
                }}
              >
                Sign In
              </Button>
            )}
          </Box>

          {/* Mobile Navigation */}
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <MobileMenu />
          </Box>
        </Toolbar>
      </Container>
    </AppBar >
  );
}

export default Header;
